import {observer} from "mobx-react";
import {useState} from "react";
import {AccordionContentComponent} from "./components/content/accordion-content.component";
import {AccordionHeaderComponent} from "./components/header/accordion-header.component";

interface AccordionProps {
    title?: React.ReactElement;
    isTitleCentered: boolean;
    content: React.ReactElement;
}
export const AccordionComponent: React.FC<AccordionProps> = observer((props) => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleIsOpen = () => {
        setIsOpen(!isOpen)
    }

    return (
        <div>
            <AccordionHeaderComponent
                title={props.title}
                isOpen={isOpen}
                isTitleCentered={props.isTitleCentered} 
                toggleIsOpen={toggleIsOpen}
                />
            <AccordionContentComponent content={props.content} isOpen={isOpen}/>
        </div>
    )
})